import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { NotificationService } from './services/shared/notification.service';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  providers: [MessageService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'cognos-dashboard';

  private _showNotificationSubscription: Subscription | null = null;

  constructor(
    private _notificationService: NotificationService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {
    this._showNotificationSubscription = this._notificationService
      .showNotification()
      .subscribe((notificationValue) => {
        this._messageService.add(notificationValue);
      });
  }

  ngOnDestroy(): void {
    this._showNotificationSubscription?.unsubscribe();
  }
}
